<template>
  <UserLayout :isContained="false">
    <!-- container-max-width -->
    <div class="">
      <section>
        <div
          class="flex justify-between bg-smokeWhite w-full rounded-lg px-6 py-8 mb-6 flex-col md:flex-row"
          v-if="userProfileDetails && userProfileDetails.verified && userProfileDetails.verified !== 1"
        >
          <div class="flex items-center">
            <div class="bg-black rounded-md">
              <img
                :src="require(`@/assets/img/email.png`)"
                class=""
                alt="email.png"
              />
            </div>
            <div class="flex flex-col ml-5">
              <span class="font-semibold text-2xl text-blacklight"
                >Verify your email to purchase classes</span
              >
              <span class="text-base font-normal text-blacklight"
                >Check your email and click this link to acticate your
                account</span
              >
            </div>
          </div>
          <div class="flex md:justify-end justify-center mt-4 md:mt-0">
            <button
              class="w-52 text-white bg-blacklight px-6 py-4 text-xl rounded-lg font-semibold"
              @click="onclickResendEmail"
            >
              Resend Email
            </button>
            <!-- <button
              v-if="showUpdateEmailButton"
              class="text-white bg-green-light px-8 py-5 rounded-lg ml-4 font-semibold focus:outline-none"
              @click="openUpdateEmailModal = true"
            >
              Update Email
            </button> -->
          </div>
        </div>

        <div
          class="flex justify-between bg-smokeWhite w-full rounded-lg px-6 py-6 mb-6"
          v-if="selectedTimezone === null"
        >
          <div class="flex items-center">
            <div class="bg-black rounded-md">
              <img
                :src="require(`@/assets/img/email.png`)"
                class=""
                alt="email.png"
              />
            </div>
            <div class="flex flex-col ml-5">
              <span class="font-semibold text-2xl">Update your timezone</span>
              <span class="text-xs font-normal"
                >Get personalized timings of classes. Click this link to update
                your timezone</span
              >
            </div>
          </div>
          <button
            class="w-52 text-white bg-blacklight px-6 py-4 text-xl rounded-lg font-semibold"
            @click="updateTimezoneModal"
          >
            Update
          </button>
        </div>
      </section>

      <!-- <Modal
        :title="'Update your Email Address'"
        :headerClass="'text-xl pt-1'"
        v-model="openUpdateEmailModal"
        :classStr="'max-w-lg'"
        class="modal"
        :whiteCross="'text-white text-4xl'"
      >
        <p class="text-md font-semibold">Update your Email Address</p>
        <input
          type="text"
          placeholder="Update Email Address"
          v-model="email"
          class="font-normal text-sm leading-5 text-gray-slate ring-1 ring-gray-400 w-full rounded-lg my-4 py-2 px-3 focus:outline-none"
        />
        <div class="py-3 flex flex-row-reverse">
          <button
            class="text-white bg-green-light px-6 py-3 rounded-lg focus:outline-none"
            @click="updateEmail"
          >
            Update
          </button>
        </div>
      </Modal> -->
      <NewHomeBannerImg
        redirectBtnText="Join Now"
       />
      <section class="pb-6">
        <!-- Start of the My Upcoming classes section  -->
        <section class="md:mb-20 mb-8"
          v-if="
            userUpcomingSessions.statusCode !== 401 &&
            userUpcomingSessions.statusCode !== 404
          "
        >
          <div class="mb-6 flex justify-between">
            <h6
              class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
            >
              My Upcoming Classes
            </h6>
            <router-link :to="{ name: 'UserSessions' }">
              <button
                class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
              >
                <span class="px-1 whitespace-nowrap">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </router-link>
          </div>
          <UpcomingSessionsCard
            :data="userUpcomingSessions && userUpcomingSessions.data"
          />
        </section>
        <!-- <section class="mb-16">
          <div class="px-2 mb-4 flex justify-between">
            <h6
              class="md:text-2xl text-xl font-semibold leading-normal mt-0 text-gray-dark"
            >
              Recent Classes
            </h6>
          </div>
          <RecentClassesCard
            :data="
              userRecentClasses &&
              userRecentClasses.data &&
              userRecentClasses.data.data
            "
          />
        </section> -->

        <!-- Start of the Available classes section  -->
        <section class="md:mb-20 mb-8">
          <div class="mb-6 flex justify-between">
            <h6
              class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
            >
              Available Classes
            </h6>
            <router-link
              v-if="
                userTrendingSessions &&
                userTrendingSessions.data &&
                userTrendingSessions.data.data > 4
              "
              class="text-green-light text-xl leading-7 font-normal tracking-tighter"
              :to="{
                name: 'AllSessions',
                params: {
                  data:
                    userTrendingSessions &&
                    userTrendingSessions.data &&
                    userTrendingSessions.data.data,
                },
              }"
            >
              See all classes
            </router-link>
          </div>
          <AvailbaleSessions
            :data="
              userTrendingSessions &&
              userTrendingSessions.data &&
              userTrendingSessions.data.data
            "
            :statusCode="
              userTrendingSessions && userTrendingSessions.statusCode
            "
          />
        </section>
        <!-- <TopCategoriesCardListCarousel :data="categoriesList" /> -->
        <!-- Start of the Available courses section  -->
        <section class="md:mb-20 mb-8">
          <div class="mb-6 flex justify-between">
            <h6
              class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
            >
              Available Class Packs
            </h6>
            <router-link
              v-if="
                userTrendingCourses &&
                userTrendingCourses.data &&
                userTrendingCourses.data.data > 4
              "
              class="text-green-light text-xl leading-7 font-normal tracking-tighter"
              :to="{
                name: 'AllSessions',
                params: {
                  data:
                    userTrendingCourses &&
                    userTrendingCourses.data &&
                    userTrendingCourses.data.data,
                },
              }"
            >
              See all courses
            </router-link>
          </div>
          <AvailableCourses
            :data="
              userTrendingCourses &&
              userTrendingCourses.data &&
              userTrendingCourses.data.data
            "
            :statusCode="userTrendingCourses && userTrendingCourses.statusCode"
          />
        </section>

        <!-- Recommended Sessions -->
        <section class="md:mb-20 mb-8"
          v-if="
            getToken() &&
            userRecommendedSessions &&
            userRecommendedSessions.data &&
            userRecommendedSessions.data.data
          "
        >
          <div class="mb-6 flex justify-between">
            <h6
              class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
            >
              Recommended Classes
            </h6>
          </div>
          <RecommendedSessionCardListCarousel
            :data="
              userRecommendedSessions &&
              userRecommendedSessions.data &&
              userRecommendedSessions.data.data
            "
            :statusCode="
              userRecommendedSessions && userRecommendedSessions.statusCode
            "
          />
        </section>

        <!-- Recommended Class Packs -->
        <section class="md:mb-20 mb-8"
          v-if="
            getToken() &&
            userRecommendedCourses &&
            userRecommendedCourses.data &&
            userRecommendedCourses.data.data
          "
        >
          <div class="mb-6 flex justify-between">
            <h6
              class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
            >
              Recommended Class Packs
            </h6>
          </div>
          <RecommendedSessionCardListCarousel
            :data="
              userRecommendedCourses &&
              userRecommendedCourses.data &&
              userRecommendedCourses.data.data
            "
            :statusCode="
              userRecommendedCourses && userRecommendedCourses.statusCode
            "
          />
        </section>
      </section>
      <section class="max"></section>
      <Modal
        :title="'Update Timezone'"
        :headerClass="'text-xl pt-1'"
        v-model="timezoneModalOpen"
        :classStr="'max-w-lg'"
        class="modal"
        :whiteCross="'text-white text-4xl'"
      >
        <p class="text-md font-semibold">Update your timezone</p>
        <p class="text-md font-medium text-gray-smoke pt-1 pb-3">
          Select your timezone
        </p>
        <div class="mb-20">
          <!-- <select
            name="select"
            id="select"
            class="px-2 mt-4 w-full py-3 ring-1 bg-white ring-gray-400 focus:outline-none rounded-md appearance-none text-gray-light"
            v-model="selectedTimezone"
            @change="changeTimezone($event)"
          >
            <option v-for="(t, i) in timezones" :key="i" :value="t.id">
              {{ t.display_name }}
            </option>
          </select> -->
          <model-list-select
            :list="getTimezoneDetails"
            v-model="selectedTimezone"
            option-value="id"
            option-text="display_name"
            placeholder="select item"
          >
          </model-list-select>
        </div>
        <div class="py-3 flex flex-row-reverse">
          <button
            class="text-white bg-green-light px-6 py-3 rounded-lg focus:outline-none"
            @click="updateTimezone"
          >
            Update
          </button>
        </div>
      </Modal>
      <UpdateTimeZoneModal></UpdateTimeZoneModal>
      <ConfirmationModal
        v-if="becomeTrainerModal"
        :confirmationModalOpen="becomeTrainerModal"
        modalTitle="Become a Trainer"
        :modalCancelHandler="becomeTrainerModalCancelhandler"
        :confirmModalHandler="becomeTrainerModalConfirmHandler"
        :isCancellable="true"
        modalConfirmText="Become a Trainer"
        modalQuestion="You just registered as an Attendee. Do you want to become a trainer ?"
        maintainCancelCookie="fitclass_socialModalFlag"
      ></ConfirmationModal>
    </div>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import NewHomeBannerImg from "@/components/NewHomeBannerImg";
import UpcomingSessionsCard from "@/components/UpcomingSessionsCard";
// import RecentClassesCard from "@/components/RecentClassesCard";
import TopCategoriesCardListCarousel from "@/components/TopCategoriesCardListCarousel";
import LiveSessionCardListCarousel from "@/components/user/LiveSessionCardListCarousel";
import TrendingSessionCardListCarousel from "@/components/TrendingSessionCardListCarousel";
import AvailbaleSessions from "@/components/AvailableSessions";
import AvailableCourses from "@/components/AvailableCourses";
import RecommendedSessionCardListCarousel from "@/components/RecommendedSessionCardListCarousel";
import TrainerCardListCarousel from "@/components/user/TrainerCardListCarousel";
import UserTrainerPostListCarousel from "@/components/user/UserTrainerPostListCarousel";
import NewsLetter from "@/components/NewsLetter";
import { mapGetters, mapActions } from "vuex";
import {Modal, UpdateTimeZoneModal, ConfirmationModal} from "@/components/t-components";
import * as Cookies from 'js-cookie'
import moment from 'moment-timezone';
import store from "@/store";
// import { required } from "vuelidate/lib/validators";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "NewHome",
  components: {
    AvailbaleSessions,
    AvailableCourses,
    UserLayout,
    NewHomeBannerImg,
    UpcomingSessionsCard,
    // RecentClassesCard,
    TopCategoriesCardListCarousel,
    LiveSessionCardListCarousel,
    TrendingSessionCardListCarousel,
    RecommendedSessionCardListCarousel,
    TrainerCardListCarousel,
    UserTrainerPostListCarousel,
    NewsLetter,
    Modal,
    UpdateTimeZoneModal,
    ConfirmationModal,
    ModelListSelect,
  },
  // validations: {
  //   email: {
  //     required,
  //     validEmail(email) {
  //       var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  //       if (regex.test(email)) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     },
  //   },
  // },
  data() {
    return {
      currentPage: 1,
      // LOADING: true,
      // showUpdateEmailButton: true,
      timezoneModalOpen: false,
      // email: null,
      // openUpdateEmailModal: false,
      // timezones: {},
      selectedTimezone: null,
      becomeTrainerModal: false
    };
  },
  computed: {
    ...mapGetters([
      "userUpcomingSessions",
      "userLiveSession",
      "userTrendingSessions",
      "userTrendingCourses",
      "userRecommendedSessions",
      "userRecommendedCourses",
      "userFollowedTrainerPosts",
      "categoriesList",
      "topTrainerList",
      "getTimezoneDetails",
      // "userRecentClasses",
      "userProfileDetails",
    ]),
  },
  methods: {
    ...mapActions([
      "getUserUpcomingSessions",
      "getUserLiveSession",
      "getUserTrendingSessions",
      "getUserTrendingCourses",
      "getUserRecommendedSessions",
      "getUserRecommendedCourses",
      "getUserFollowedTrainerPosts",
      "getCategoriesList",
      "postTopTrainerList",
      "timezone",
      "updateTimezoneForUser",
      // "updateUserEmailId",
      // "getUserRecentClasses",
      "resendVerificationEmail",
      "getUserProfileDetails",
    ]),

    imgLoadHandler() {
      // this.LOADING = false;
      store.commit("setIsLoading", false);
    },
    updateTimezoneModal() {
      this.timezoneModalOpen = true;
    },
    // changeTimezone(event) {
    //   this.selectedTimezone = event.target.value;
    // },
    async updateTimezone() {
      store.commit("setIsLoading", true);
      await this.updateTimezoneForUser(this.selectedTimezone);
      this.timezoneModalOpen = false;
    },

    // async updateEmail() {
    //   this.$v.$touch();
    //   if (this.$v.email.$error) {
    //     return false;
    //   }
    //   const data = {
    //     email: this.email,
    //   };
    //   store.commit("setIsLoading", true);
    //   await this.updateUserEmailId(data);
    // this.openUpdateEmailModal = false;
    // store.commit("setIsLoading", false);
    // this.showUpdateEmailButton = false;
    // },

    onclickResendEmail() {
      const data = {
        //   email: this.getUser() && this.getUser().email,
        id: this.getUser() && this.getUser().id,
      };
      // this.resetPassword(data);
      this.resendVerificationEmail(data);
    },
    becomeTrainerModalCancelhandler () {
      this.becomeTrainerModal = !this.becomeTrainerModal
    },
    becomeTrainerModalConfirmHandler () {
      this.becomeTrainerModalCancelhandler()
      this.$router.push({ name: "Register" });
    },
    checkSocialLoginRegsiter () {
      let user = JSON.parse(localStorage.getItem("user"));
      const isSocialModalCookieSet = Cookies.get('fitclass_socialModalFlag')
      var dateToCompare = user.created_at;
      // Get the current date in the user's local browser timezone
      var currentDate = moment().format("YYYY-MM-DD");
      // Compare the date parts only
      if (user && user.google_id && user.google_id.length && !user.last_login && !isSocialModalCookieSet && moment(dateToCompare).isSame(currentDate, 'day')) {
        this.becomeTrainerModal = true
      }
    }
  },
  async created() {
    store.commit("setIsLoading", true);
    this.selectedTimezone = this.getUser() && this.getUser().timezone;
    await this.timezone();
    // this.timezones = this.getTimezoneDetails;
    const query = {
      page: this.currentPage,
    };
    await this.$store.dispatch('getLandingBannerData', 'ATTENDEE_HOMEPAGE')
    this.imgLoadHandler()
    this.checkSocialLoginRegsiter()
    await this.getUserUpcomingSessions({ query });
    await this.getUserTrendingSessions({ query });
    await this.getUserTrendingCourses({ query });
    await this.getUserRecommendedSessions({ query });
    await this.getUserRecommendedCourses({ query });
    // await this.getUserRecentClasses({ query });

    // this.getUserLiveSession({ query });
    this.postTopTrainerList();
    this.getCategoriesList();
    this.getUserProfileDetails();
    // if (this.getToken()) {
    //   this.getUserFollowedTrainerPosts({ query });
    // }
  },
};
</script>